import React, { useEffect, useState } from 'react'
import './game-images.styles.scss'

import { resizeImage } from '@/utils/resizeImage';
import { useSelector } from 'react-redux';
import { ModalAlert } from '@/components/modal/modal.component';
import placeholderHead from '@/assets/placeholder-head.jpg'
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const GameHeaderUpload = ({
  saveData,
  formData,
  onApprove,
  setContentManagerElement,
  tempHeader,
  setTempHeader
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [showModal, setShowModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [resizedImage, setResizedImage] = useState(null);
  const root = useSelector(state => state.userData.root);

  useEffect(() => {
    console.log(onApprove)
    if (!onApprove) { return; }
    saveChosenHeader();
  }, [onApprove])

  function clickInput() {
    const input = document.getElementById('headerFileUpload');
    if (input) {
      input.click();
    }
  }

  async function handleUpload(file) {
    // document.getElementById('selected-header').classList.add('hide')
    console.log(file.type);
    console.log(file.name);
    if (file.type.match(/image.*/)) {
      // const newFile = window.URL.createObjectURL(file)
      if (!file.type.includes('gif')) {
        const newImage = await resizeImage(file, file.type)
        console.log(newImage)
        setResizedImage(newImage);
        const imageUrl = window.URL.createObjectURL(file)
        // c
        setTempHeader({
          'name': file.name,
          'url': imageUrl,
          'upload': true
        })
      } else {
        setTempHeader({
          'name': file.name,
          'url': imageUrl,
          'upload': true
        })
      }
    } else {
      setAlertMessage('Please upload an image file.');
      return;
    }
  }

  function chooseIcon(path) {
    setShowModal(false);
    setTempHeader({ 'url': `${root}/${path}`, 'upload': false })
    // saveData('header', {upload: false, url: `${root}/${path}`});
  }

  function saveChosenHeader() {
    if (tempHeader && tempHeader.upload) {
      saveData('header', { 'upload': true, 'url': tempHeader.url, 'file': resizedImage, 'name': tempHeader.name })
    } else {
      saveData('header', { 'upload': false, 'url': tempHeader.url, 'name': tempHeader.name })
    }
  }

  function pickFromMyContent() {
    setContentManagerElement('gameHeader');
  }

  return (
    <div className='new-game-form'>
      {/* <h4>Game Header  <span className='required'>*</span></h4><hr /> */}
      <div className={`image-upload-form ${screenSize}`}>
        <div className={`icon-buttons center ${screenSize}`}>
          <button
            className={`g-button ${screenSize === 'mobile' ? 'small-btn' : ''}`}
            onClick={() => pickFromMyContent()}>
            Choose an Existing Header
          </button>
          <div style={{ cursor: 'pointer' }}>
            <button
              className={`g-button ${screenSize === 'mobile' ? 'small-btn' : ''}`}
              type="button"
              tabIndex="-1"
              onClick={() => clickInput()}>
              <input
                type="file"
                accept="image/*"
                id="headerFileUpload"
                onChange={(e) => handleUpload(e.target.files[0])} />
              Upload a Custom header
            </button>
          </div>
          <div className='field small'>
            <label>Border Options <span className='meta'>(Applies to Header only)</span></label>
            <select
              value={formData.border_header || 'none'}
              onChange={(e) => saveData('border_header', e.target.value)}>
              <option value='none'>None</option>
              <option value='white'>White</option>
              <option value='black'>Black</option>
              <option value='primary'>Game Primary Color</option>
            </select>
          </div>
        </div>
        <div className="center">
          {/* <div id="selected-header">
                        {!tempHeader &&
                            <img className="game-header" referrerPolicy="no-referrer" src={placeholderHead} />
                        }
                    </div> */}
          <div id="selected-header">
            {
              (tempHeader && tempHeader.url)
                ?
                <ImageContainer
                  className={`${formData.border_header}-border`}
                  src={tempHeader.url}
                  alt='header image' />
                :
                (formData.header)
                  ?
                  <ImageContainer
                    className={`${formData.border_header}-border`}
                    src={formData.header.url ?? formData.header}
                    alt='header image' />
                  :
                  <img className='game-header' referrerPolicy='no-referrer' src={placeholderHead} />
            }
          </div>
        </div>
      </div>
      {/* <Modal show={showModal} cancel={() => pickFromMyContent()} closeButton={true} cls='full' text='Choose an existing header'>
                <div className='modal-children header-choices'>
                    {
                        existingHeaders.map((icon, index) => (
                            <div className='header-choice' key={index} onClick={() => chooseIcon(icon)}>
                                <ImageContainer src={icon} alt='header icon to choose' className='header' />
                            </div>
                        ))
                    }   
                </div> 
            </Modal> */}
      <ModalAlert show={alertMessage} cancel={() => setAlertMessage(null)} message={alertMessage} />
    </div>
  )
}

export default GameHeaderUpload